// src/pages/AdminUserLedger.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import "../user/Dashboard.css";

const isLocal = window.location.hostname === "localhost";
const baseUrl = isLocal ? "http://localhost:5000" : "https://www.trendscout.club";
const api = axios.create({ baseURL: baseUrl });

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export default function AdminUserLedger() {
  const { id } = useParams(); // userId from URL
  const [userName, setUserName] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/fund-sharing/admin/user/${id}/ledger`);
        setUserName(res.data?.userName || "(no name)");
        setRows(Array.isArray(res.data?.rows) ? res.data.rows : []);
        setErr("");
      } catch (e) {
        setErr(e?.response?.data?.error || e.message);
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) {
    return (
      <div className="dashboard-main">
        <div className="loader" style={{ marginTop: 40 }} />
      </div>
    );
  }

  return (
    <div className="dashboard-main">
      <div className="outcome-table-wrapper-dashboard">
        <div className="outcome-table">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
            <h3>Ledger — {userName}</h3>
            <Link to="/admin/fund-sharing" style={{ opacity: 0.8 }}>← Back</Link>
          </div>

          {err && <div style={{ color: "#f66", marginBottom: 10 }}>{String(err)}</div>}

          <div className="table-scroll-container">
            <table>
              <thead>
                <tr>
                  <th>When</th>
                  <th>Type</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={4} style={{ textAlign: "center", opacity: 0.7 }}>
                      No entries.
                    </td>
                  </tr>
                ) : (
                  rows.map((r, i) => (
                    <tr key={i}>
                      <td>{new Date(r.createdAt).toLocaleString()}</td>
                      <td style={{ textTransform: "capitalize" }}>{r.type}</td>
                      <td>{money(r.amount)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
